
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-terms-conditions",
      function () {
        return require("private-next-pages/referral-terms-conditions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-terms-conditions"])
      });
    }
  